import React from 'react';
import { Snackbar, Alert } from '@mui/material';

interface SnackbarItem {
  id: string;
  message: string;
  severity: 'success' | 'error' | 'info' | 'warning';
}

interface SnackbarNotificationsProps {
  snackbars: SnackbarItem[];
  hideSnackbar: (id: string) => void;
}

const SnackbarNotifications: React.FC<SnackbarNotificationsProps> = ({
  snackbars,
  hideSnackbar,
}) => {
  return (
    <>
      {snackbars.map((snackbar) => (
        <Snackbar
          key={snackbar.id}
          open={true}
          autoHideDuration={6000}
          onClose={() => hideSnackbar(snackbar.id)}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          sx={{ marginTop: `${snackbars.indexOf(snackbar) * 60}px` }} // Stack snackbars vertically
        >
          <Alert
            onClose={() => hideSnackbar(snackbar.id)}
            severity={snackbar.severity}
            sx={{ width: '100%' }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      ))}
    </>
  );
};

export default SnackbarNotifications;
